/*
 * Created by alex@hackerbay.com on 16.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../components/Header";
import TextBody from "../components/TextBody";
import Button from "@material-ui/core/es/Button/Button";
import {Col, Container, Row, Input} from "reactstrap";
import i18n from "i18next";
import genesys from "../api/genesys";
import {SpacerRow} from "../components/SpacerRow";
import BottomBarActive from "../components/BottomBarActive";
import BottomBar from "../components/BottomBar";
import TopNav from "../components/TopNav";
import TextField from '@material-ui/core/TextField';
import {BrowserView,MobileView, isMobile} from "react-device-detect";
import SubPageTopBar from "../components/SubPageTopBar";
import LoadingPage from "./LoadingPage";
import {STAGES} from "./Stage";
import {isDebugUser} from "./DebugMenu";


class Stage extends React.Component {

    /**
     * constructor
     * @param props
     */
    constructor(props){
        super(props);
        this.state = {
            phoneNumber: "",
            submitting: false
        }
    }

    /**
     * phone number input changed
     * @param event
     */
    phoneNumberInputChanged = (event) => {
        this.setState({
            phoneNumber: event.target.value,
            error: ""
        })
    };

    /**
     * Submit Callback Form
     */
    requestCallback = () => {

        // FNX
            // console.log("FNX: requestCallback / Stage: "); console.log(this.stage);
            // this.setState({callbackRequestedSuccessfully: true});
            // this.setStage(STAGES.APPOINTMENT_DAY);

        if(!this.state.phoneNumber){
            return this.setState({error: i18n.t("error_missing_phone_number")})
        }

        this.setState({submitting: true});

        // for TESTUSERS: simulate genesys API call to submit callback request to VF systems
        if( isDebugUser(this.props.urlIdent) === true ) {

            // console.log( "FNX: genesys success simulation - for testusers only - " + this.props.urlIdent);
            this.props.callbackRequestCallback();

        // for all other (regular) users -> execute error callback
        } else {

            // call genesys API to submit callback request to VF systems
            genesys(this.props.urlIdent, this.state.phoneNumber, this.props.ds360APIResult.KAS_CCB_KUNDEN_ID)
                .then(() => {
                    // console.log("FNX: genesys (on)fulfilled");
                    this.props.callbackRequestCallback();
                })
                .catch((e) => {
                    // console.log("FNX: genesys (on)rejected - " + this.props.urlIdent);
                    this.props.serverErrorCallback(e);

                });

        }
    };

    render() {
        if(this.state.submitting){
            return <LoadingPage/>
        }

        let callBackTitle = isMobile ? "callback_title" : "callback_title_desktop";
        let callBackBody1 = isMobile ? "callback_body_1" : "callback_body_1_desktop";
        let callBackBody2 = isMobile ? "callback_body_2" : "callback_body_2_desktop";
        let callBackButton = isMobile ? "request" : "request_desktop";

        // TODO FooterLnk vorbereitet zum Einbau, wenn vom PO gewünscht
		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        const callbackContent = <div>
            <SubPageTopBar
                progress={0}
                onClickClose={this.props.onClickClose}
            />
            <SpacerRow/>
            <Header
                textResource={callBackTitle}
            />
            <SpacerRow/>
            <TextBody
                textResource={callBackBody1}
            />
            <br />
            <TextBody
                textResource={callBackBody2}
            />
            <SpacerRow/>
            <TextField
                className={"width-100"}
                type={"tel"}
                label={i18n.t("contact_number")}
                onChange={this.phoneNumberInputChanged}
            />
            <p>{this.state.error}</p></div>


        const bottomBarContent = <BottomBar
            mainButtonOnClick={this.requestCallback}
            mainButtonTextResource={callBackButton}
            showFullWidth={true}
        />;

        return <Container fluid={true} style={{backgroundColor:"white",height:"100%"}}>
            <MobileView>
                <SpacerRow/>
                {callbackContent}
                <span className={"fixed-to-bottom fixed-to-bottom-nomargin"}>
                    {bottomBarContent}
                </span>
            </MobileView>
            <BrowserView>
                <Container>
                    <Row>
                        <Col sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 3 }} lg={{ size: 4, offset: 4 }}>
                            {callbackContent}
                            <SpacerRow/>
                            {bottomBarContent}
                        </Col>
                    </Row>
                </Container>

            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage);